import Backbone from 'backbone';
import _ from 'underscore';
require('backbone-relational-sync-jsonapi').default(Backbone, _);
Backbone.Relational = require('backbone-relational');
require('backbone-relational-jsonapi').default(Backbone, _);

export {Backbone};
